import { 
  StepConfirmationFormDataAPI, 
  StepContractFormDataAPI, 
  StepInstallationFormDataAPI, 
  StepPaymentFormDataAPI, 
  StepPersonFormDataAPI, 
  OwnerCompany, OwnerPerson, 
  StepGasContractFormDataAPI,
  StepsFormDataAPI
} from "../types/stepsAPI";

import { 
  IStepConfirmationFormData, 
  IStepContractFormData, 
  StepGasContractFormData, 
  IStepInstallationFormData, 
  IStepPaymentFormData, 
  IStepPersonFormData
} from "../types/stepsFormData";

export const collectInstallationFormData = (
  data: IStepInstallationFormData
): StepInstallationFormDataAPI => {
  return {
    FormConfirm: {
      allow_contact: data.leadsConsent,
      activeContract: data.activeContract,
      cups: {
        name: data.cups,
        state: data?.address?.state,
        municipi: data.address.ine,
        poblacio: data?.address.poblacio,
        tv: data?.address?.tv,
        nv: data?.address?.nv,
        pnp: data?.address?.pnp,
        bq: data?.address?.bq,
        es: data?.address?.es,
        pt: data?.address?.pt,
        pu: data?.address?.pu,
        dp: data?.address?.dp,
        aclarador: data?.address?.aclarador,
        ref_catastral: data.address.ref_catastral,
      },
      cnae: {
        cnae: data?.cnae?.id,
        vivienda: data.residenceType,
      },
      comerOrigin: data.comerOrigin || undefined,
      invoice: data.invoice || [],
      step: 1
    }
  } 
}

export const collectPersonFormData = (
  data: IStepPersonFormData,
  cupsName: string
): StepPersonFormDataAPI => {
  const owner = data.company ? 
    {
      type:  "J",
      name: data.name,
      juridic_vat: "ES" + data.vat,
      rep_name: data.nameRepresentante,
      rep_surname1: data.surName1Representante,
      rep_surname2: data.surName2Representante,
      rep_vat: data.vatRepresentante,
      rep_name_full: `${data.surName1Representante || ""} ${data.surName2Representante || ""} , ${data.nameRepresentante || ""}`
    } as OwnerCompany 
  : 
    {
      type:  "F",
      fisic_vat: data.vat,
      first_name: data.name,
      surname1: data.surName1,
      surname2: data.surName2
    } as OwnerPerson;

  if (data.changeOwner !== null) {
    owner.changeOwner = data.changeOwner;
  }

  return {
    FormConfirm: {
      cups: {
        name: cupsName
      },
      owner,
      owner_address: {
        different_address: !data.sameInvoiceAddress,
        state: data?.ownerAddress?.state,
        municipi: data?.ownerAddress?.ine,
        poblacio: data?.ownerAddress?.poblacio,
        tv: data?.ownerAddress?.tv,
        nv: data?.ownerAddress?.nv,
        pnp: data?.ownerAddress?.pnp,
        bq: data?.ownerAddress?.bq,
        es: data?.ownerAddress?.es,
        pt: data?.ownerAddress?.pt,
        pu: data?.ownerAddress?.pu,
        zip: data?.ownerAddress?.dp,
        aclarador: data?.ownerAddress?.aclarador,
        mobile: data.mobile,
        email: data.email,
        ref_catastral: data.ownerAddress.ref_catastral
      },
      ...(data.company && {cif: data.nifEmpresa[0]}), 
      commsLanguage: data.commsLanguage,
      nif_faceup: data.nifFaceup?.[0] || null,
      nif_facedown: data.nifFaceup?.[1] || null,
      step: 2
    }
  }
}

export const collectContractFormData = (
  data: IStepContractFormData,
  cupsName: string
): StepContractFormDataAPI => {

  return {
    FormConfirm: {
      cups: {
        name: cupsName
      },
      power: data.power,
      power2: data.power2,
      power3: data.power3,
      power4: data.power4,
      power5: data.power5,
      power6: data.power6,
      promotional_code: data.promotionalCode ? [data.promotionalCode] : [],
      tarifa: data.selectedProduct,
      tarifaATR: data.accessTariff,
      selfconsCode: data.selfconsCode,
      selfcons_attach: data.selfconsAttachments,
      step: 3
    }
  }
}

export const collectGasContractFormData = (
  data: StepGasContractFormData,
  electricityLeadId?: number
): StepGasContractFormDataAPI => {

  return {
    FormConfirm: {
      cups: {
        name: data.cups
      },
      invoice: data.invoice,
      tarifa: data.selectedProduct,
      tarifaATR: data.accessTariff,
      electricityLeadId,
      step: 3
    }
  }
}

export const collectPaymentFormData = (
  data: IStepPaymentFormData,
  cupsName: string
): StepPaymentFormDataAPI => {

  return {
    FormConfirm: {
      cups: {
        name: cupsName
      },
      bank: {
        iban: data.iban,
        owner_is_bank_owner: data.isOwner
      },
      step: 4
    }
  }
}

export const collectConfirmationFormData = (
  data: IStepConfirmationFormData,
  cupsName: string
): StepConfirmationFormDataAPI => {

  return {
    FormConfirm: {
      cups: {
        name: cupsName
      },
      accept_gdpr: data.acceptGdpr || false,
      accept_ov_conditions: data.acceptOVConditions || false,
      activate_publicity: data.acceptPublicity || false,
      confirm: true,
      step: 5
    }
  }
}

export const collectElecFormData = (
  stepsData: {
    installation: IStepInstallationFormData,
    person: IStepPersonFormData,
    contract: IStepContractFormData,
    payment: IStepPaymentFormData,
  }
): StepsFormDataAPI => {

  return {
    FormConfirm: {
      ...collectPersonFormData(stepsData.person, stepsData.installation.cups).FormConfirm,
      ...collectContractFormData(stepsData.contract, stepsData.installation.cups).FormConfirm,
      ...collectPaymentFormData(stepsData.payment, stepsData.installation.cups).FormConfirm,


      // Important: This step must be the last to mantain the cups structure
      ...collectInstallationFormData(stepsData.installation).FormConfirm,
      step: 5
    }
  }
}

export const collectDualGasFormData = (
  stepsData: {
    installation: IStepInstallationFormData,
    person: IStepPersonFormData,
    gasContract: StepGasContractFormData,
    payment: IStepPaymentFormData,
  },
  electricityLeadId: number
): StepsFormDataAPI => {
  
  // Must do this because otherwise the electricity comer id
  // is not found in the gas comer available ids and fails 
  stepsData.installation.cups = stepsData.gasContract.cups;
  stepsData.installation.comerOrigin = stepsData.gasContract.comerOrigin;

  return {
    FormConfirm: {
      ...collectPersonFormData(stepsData.person, stepsData.installation.cups).FormConfirm,
      ...collectGasContractFormData(stepsData.gasContract, electricityLeadId).FormConfirm,
      ...collectPaymentFormData(stepsData.payment, stepsData.installation.cups).FormConfirm,

      // Important: This step must be the last to mantain the cups structure
      ...collectInstallationFormData(stepsData.installation).FormConfirm,
      step: 5
    }
  }
}

export const collectGasFormData = (
  stepsData: {
    installation: IStepInstallationFormData,
    person: IStepPersonFormData,
    gasContract: StepGasContractFormData,
    payment: IStepPaymentFormData,
  }
): StepsFormDataAPI => {

  return {
    FormConfirm: {
      ...collectPersonFormData(stepsData.person, stepsData.installation.cups).FormConfirm,
      ...collectGasContractFormData(stepsData.gasContract).FormConfirm,
      ...collectPaymentFormData(stepsData.payment, stepsData.installation.cups).FormConfirm,

      // Important: This step must be the last to mantain the cups address structure
      ...collectInstallationFormData(stepsData.installation).FormConfirm,
      step: 5
    }
  }
}